export default {
    _home: '首页',
    home: '首页',

    'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',

    usermanage: '用户管理',
    user: '用户列表',
    role: '角色管理',
    functions: '权限列表',
    menus: '菜单组件',
    systemmanage: '系统管理',
    system: '系统配置',
    systemlog: '系统日志',

  scinfo: '市场管理',
  sc_market: '市场信息管理',
  scinfo_jobfair: '招聘会管理',
  scinfo_room: '面试室管理',
  company: '企业管理',
  company_info: '企业基础信息管理',
  company_job: '职位管理',
  person: '求职者管理',
  person_info: '求职者信息管理',
  person_tocompany: '求职管理',
  machine: '设备管理',
  machine_scmachine: '市场设备管理',
  machine_interview: '面试服务管理',
  account: '信息管理',
  account_company_info: '基础信息管理',
  apply: '招聘管理',
  apply_jobfair: '远程面试',
  apply_job: '职位管理',
  apply_application: '应聘管理',
  report: '大数据中心',
  report_company: '注册企业明细',
  report_jobfair: '市场信息统计表',
  report_job: '职位信息汇总表',
  report_statistics: '市场汇总统计表',
  report_jobfair_signin: '市场签到表',
  report_supply_mon: '月度供求统计表',
  report_place: '安置就业',
  activity: '活动',
  voteshow: '投票',
  company_other: '企业服务',
  tcrc_zm: '芝麻背调',
  js_zhy: '江苏省智慧就业云平台',
  personnel: '人才编码',
  personnelapply: '预约记录',
  personnelapplyconfig: '预约设置',
  special_area: '专区管理',
  soldier: '退役军人专区',
  soldier_job: '退役军人_职位',
  soldier_person: '退役军人_个人',
  soldier_person_tocompany: '退役军人_求职',
  soldier_jobfair: '退役军人_招聘会',
  allopatry: '医疗保障管理',
  allopatryinfo: '居外就医申请',
  dispatch: '劳务派遣用工登记',
  dispatch_info: '派遣机构管理',
  dispatch_person: '用工管理',
  dispatch_all: '用工情况查询',
  cripple_job: '残疾人_职位',
  cripple_person: '残疾人_个人',
  cripple_person_tocompany: '残疾人_求职',
  cripple_jobfair: '残疾人_招聘会',
  hr_bussiness: '人力资源',
  hr_bussiness_config: '业务设置',
  hr_bussiness_info: '求职跟踪服务',
  ljtc: '乐就小程序',
  school_jobfair: '高校网络招聘会',
  assist_s: '援助服务',
  assist_server: '援助服务',
  assist_kpi: '援助服务再分配',
  assist: '援助人员管理',
  assist_person: '援助人员信息管理',
  assist_parameter: '参数管理',
  assist_out: '援助情况反馈',
  news: '公告管理',
  news_info: '公告管理',
  workforce: '劳动力情况',
  workforce_info: '劳动力数据管理',
  workforce_analyse: '劳动力分析',
  labor: '劳务派遣',
  labor_company: '协作单位管理',
  labor_contract: '合同管理',
  labor_business: '派遣业务管理',
  law: '法律服务',
  law_info: '法律服务',
  cost: '费用管理',
  cost_info: '费用管理',
  testimonials: '推荐管理',
  testimonials_info: '推荐管理',
  evaluations: '评价管理',
  evaluations_info: '评价管理',
  apply_person: '人才管理',
  temporary_job: '临时招聘管理',
  jobs: '职位管理',
  interview: '应聘管理',
  broker_job: '委托招聘管理',
  job_audit: '临时招聘审核',
  per_audit: '零工意向审核',
  room: '宿舍管理',
  room_info: '房间管理',
  bed_info: '床位管理',
  report_job_hz: '职位汇总表',
  report_per_hz: '零工意向汇总表',
  company_job_alarm: '职位预警推送',
  report_main:'驾驶舱',
  report_zcfbqk:'注册发布情况调度表累计表',
  report_zcfbhz:'注册发布汇总表(区镇)',
  report_school:'院校注册情况'
}
